import { NormalizedObjects } from 'interfaces/entities';
import { getAllIds } from './allIds';
import { getById } from './byId';

export function getNormalizedObject(
  arrayOfObjects: Array<any>,
  idIdentifier: string,
  previousNormalizedObject?: NormalizedObjects<any> | null | undefined
) {
  const normalizedObject = {
    byId: {},
    allIds: [],
  };
  normalizedObject.byId = getById(
    arrayOfObjects,
    idIdentifier,
    previousNormalizedObject
  );
  normalizedObject.allIds = getAllIds(
    arrayOfObjects,
    idIdentifier,
    previousNormalizedObject
  );
  return normalizedObject;
}

export const isJsonString = (str: string) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const updateHistory = (pathname: string, audienceId?: string) => {
  const { search } = window.location;
  const path = audienceId
    ? `${pathname}/${audienceId}${search}`
    : `${pathname}/${search}`;
  window.history.pushState(null, document.title, `${path}`);
};
